<section [formGroup]="formGroup" class="select-terminal-component">
  <h6 class="fs-5">{{ 'terminal_terminal' | translation }}</h6>
  <mat-form-field appearance="fill" class="w-100 select-terminal">
    <mat-label>{{ 'terminal_terminal' | translation }}</mat-label>
    <mat-select formControlName="terminal"  (selectionChange)="onTerminalChange($event.value)">
      <mat-optgroup *ngFor="let groupName of getGroupedFieldNames()" [label]="groupName">
        <mat-option *ngFor="let singleTerminal of terminalsGroupedByField[groupName]"
                    [value]="singleTerminal">
          <lib-terminal-header
            class="mt-5"
            [equipment]="singleTerminal"
            [showButton]="false"
            [enableLink]="false"
            [showStatusIcon]="false"
            [modeMatSelect]="true">
          </lib-terminal-header>
        </mat-option>
      </mat-optgroup>
      <mat-optgroup [label]="'devices_no_field' | translation">
        <mat-option *ngFor="let singleTerminal of terminalsWithoutField" [value]="singleTerminal">
          <lib-terminal-header
            class="mt-5"
            [equipment]="singleTerminal"
            [showButton]="false"
            [enableLink]="false"
            [showStatusIcon]="false"
            [modeMatSelect]="true">
          </lib-terminal-header>
        </mat-option>
      </mat-optgroup>
    </mat-select>
    <ng-container *ngIf="terminal">
      <lib-terminal-header
        class="mt-5"
        [equipment]="terminal"
        [showButton]="false"
        [enableLink]="false"
        [showStatusIcon]="false"
        [modeMatSelect]="true"
      ></lib-terminal-header>
    </ng-container>
  </mat-form-field>
</section>
